import { authTypes } from '../auth/types'
import {
    Trades, tradeTypes,
    TradeTypesActions
} from './types'

const initialState: Trades = null

const reducer = (state = initialState, action: TradeTypesActions): Trades => {
  const { type, payload } = action

  switch (type) {
    case authTypes.LOGIN_REQUEST: { return initialState }
    case authTypes.LOGOUT_REQUEST: { return initialState }

    case tradeTypes.SET_TRADE_TYPES: {
      return payload as Trades
    }

    default:
      return state
  }
}

export default reducer
